import React, { useCallback } from 'react';
import { GridControlsDropDownTemplateProps } from 'models/grid';
import { GridModel } from '../../models';
import { ListItemText, MenuItem } from '@mui/material';
import { useTranslate } from 'hooks/use-translate';
import { composeFunctions } from 'utils';
import vars from 'styles/variabels.module.scss';
import EditIcon from '@mui/icons-material/Edit';

interface Props extends GridControlsDropDownTemplateProps<GridModel> {}
export const ControlEdit: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  data,
  onTask,
  handleClose,
}) => {
  const { tp } = useTranslate();

  const onClick = useCallback(
    () => onTask([['onHandle', { type: 'edit', id, data }]]),
    [onTask, data, id],
  );

  return (
    <MenuItem
      style={{ color: vars.colorPrimary }}
      disabled={data.isManually === false}
      onClick={composeFunctions(onClick, handleClose)}
    >
      <EditIcon fontSize="small" />
      <ListItemText> {tp('edit')}</ListItemText>
    </MenuItem>
  );
};
